import Lightbox from '../../../js/lightbox'

const galleries = document.querySelectorAll('.wp-block-gallery')

const lightbox= new Lightbox(galleries)